import {
  toReactNodes
} from "./chunk-3NZOR3KT.js";
import {
  StyledTitle,
  getPropDefaults
} from "./chunk-IVEDTGKR.js";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/Title.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Title(props) {
  const propsWithDefaults = getPropDefaults(props);
  let reactNodes = props.children || null;
  if (props.content) {
    reactNodes = toReactNodes(props.content);
  }
  return /* @__PURE__ */ jsx(StyledTitle, __spreadProps(__spreadValues({}, propsWithDefaults), { children: reactNodes }));
}

export {
  Title
};
